// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  // DEV ambient is used
  production: false,
  defaultLanguage: "es",
  password: "123456",
  isDeactivateGuardEnabled: false,
  useEncription: true,
  settingsFile: "settings",
  apiBaseUrl: "https://appservice2-1660905.azurewebsites.net/api",
  //apiBaseUrl: "http://localhost:58249/api",
};



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/environments/environment.ts